var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKesFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v45H0V0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v13.5H0V0Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 31.5h60V45H0V31.5Z",
    fill: "#060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.956 35.86.507.28 13.134-22.78c.76-.17 1.181-.9 1.603-1.632.281-.506 1.406-2.447 1.885-4.978a16.312 16.312 0 0 0-3.347 4.134c-.422.732-.844 1.463-.647 2.222L21.956 35.86Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m39.3 6.371-.077.405c-.463 2.45-1.526 4.35-1.86 4.95l-.04.07v.001l-.005.008c-.208.36-.424.736-.686 1.041-.252.294-.554.533-.943.636L22.515 36.33l-.752-.418 13.178-22.828c-.088-.396-.024-.78.109-1.148.138-.38.354-.755.562-1.117l.003-.005a16.451 16.451 0 0 1 3.376-4.17l.308-.274Zm-.44.775a16.17 16.17 0 0 0-3 3.808c-.213.369-.417.723-.545 1.079-.128.352-.177.695-.088 1.038l.014.056L22.15 35.806l.26.145 13.096-22.715.06-.014c.34-.075.611-.278.852-.559.243-.283.448-.636.66-1.004l.038-.069c.313-.56 1.255-2.245 1.744-4.444Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.956 35.86.507.28 13.134-22.78c.76-.17 1.181-.9 1.603-1.632.281-.506 1.406-2.447 1.885-4.978a16.312 16.312 0 0 0-3.347 4.134c-.422.732-.844 1.463-.647 2.222L21.956 35.86Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.047 15.75H35.344C34.5 13.5 31.688 9 30 9c-1.687 0-4.5 4.5-5.344 6.75H-.019v13.5h24.675C25.5 31.5 28.313 36 30 36c1.688 0 4.5-4.5 5.344-6.75h24.703v-13.5Z",
    fill: "#B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.344 29.25c.843-2.25 1.406-4.5 1.406-6.75s-.563-4.5-1.406-6.75c-.844 2.25-1.407 4.5-1.407 6.75s.563 4.5 1.407 6.75Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 24.188c.621 0 1.125-.756 1.125-1.688 0-.932-.504-1.688-1.125-1.688s-1.125.756-1.125 1.688c0 .932.504 1.688 1.125 1.688Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.281 24.131s1.125 2.25 1.125 5.907c0 3.656-1.125 5.906-1.125 5.906V24.13Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKesFlag);
export default __webpack_public_path__ + "static/media/kes-flag.072a83b1b789f8a421ff4500a1a370d4.svg";
export { ForwardRef as ReactComponent };